
<div *ngIf="loading" class="loading-loader">

  <div class="loading-loader-wrapper">
    <div class="loading-loader-container">
      <mat-spinner diameter="40" ></mat-spinner>
      <strong class="margin-10" *ngIf="showtext" i18n="@@loader_loading">Caricamento...</strong>
    </div>
  </div>

</div>

<div *ngIf="error" class="error-loader">

  <div class="error-loader-wrapper">
    <div class="error-loader-container">
      <fa-icon class="loader-error-icon" icon="exclamation-triangle"></fa-icon>
      <strong class="margin-10" *ngIf="showtext" i18n="@@loader_error">Errore</strong>
    </div>
  </div>

</div>

<div *ngIf="successAnimation" class="success-checkmark">
  <div class="check-icon">
    <span class="icon-line line-tip"></span>
    <span class="icon-line line-long"></span>
    <div class="icon-circle"></div>
    <div class="icon-fix"></div>
  </div>
</div>

